<template>
  <div>
    <v-subheader :class="`${backgroundColor} ${textColor} guest-list-header text-h6 font-weight-medium`">
      {{ title }}
    </v-subheader>
    <v-divider />
  </div>
</template>

<script lang='ts'>
import Vue from 'vue';

export default Vue.extend({
  name: 'GuestListHeaderRow',
  props: {
    title: { type: String, required: true },
  },
  computed: {
    textColor(): string {
      return this.$vuetify.theme.dark ? 'grey--text' : 'secondary--text';
    },
    backgroundColor(): string {
      return this.$vuetify.theme.dark ? 'black' : 'grey lighten-3';
    },
  },
});
</script>

<style scoped>

  .guest-list-header {
    height: 24px !important;
    font-size: 1.15rem !important;
  }

</style>
